import { AppearanceError } from './errors.js';

/*
 * The Card page's QR style (CLAUDE.md §4 "Card", Saif 21 Oct 2026), an admin setting: "flip" (now "Tap to show": the
 * card carries no code; tapping it or Show code opens a clean full-screen QR; the stored value keeps its old name so
 * nothing migrates) or "front" (the QR on the card's face, tap to enlarge to the same sheet). Stored as site_settings row
 * `app_card`, served in GET /api/appearance as `card: { qrStyle }`.
 */

export const QR_STYLES = ['flip', 'front'] as const;
export type QrStyle = (typeof QR_STYLES)[number];
export const QR_STYLE_NAMES: Record<QrStyle, { label: string; sub: string }> = {
  flip: { label: 'Tap to show', sub: 'The card shows the name, points and credit; tapping it or Show code opens a large, bright QR' },
  front: { label: 'On the front', sub: 'The QR sits on the card’s face; tapping it opens the same large QR' },
};

export interface CardSetting { qrStyle: QrStyle }
export const DEFAULT_CARD: CardSetting = { qrStyle: 'flip' };

/** The setting to save, checked. */
export function checkCard(raw: unknown): CardSetting {
  const o = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  if (!(QR_STYLES as readonly unknown[]).includes(o.qrStyle)) throw new AppearanceError('The QR style is "flip" or "front"', 'bad_card');
  return { qrStyle: o.qrStyle as QrStyle };
}

/** The stored setting, read leniently: anything unreadable takes the starting value. */
export function storedCard(raw: unknown): CardSetting {
  const o = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  return { qrStyle: (QR_STYLES as readonly unknown[]).includes(o.qrStyle) ? (o.qrStyle as QrStyle) : DEFAULT_CARD.qrStyle };
}
